"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _default = function _default(sessionName) {
  var validSessionName = sessionName;

  if (!sessionName) {
    console.error("DEFAULTING TO \"".concat(_constants.DEFAULT_SESSION_NAME, "\" as no session name provided"));
    validSessionName = _constants.DEFAULT_SESSION_NAME;
  }

  var sessionData = sessionStorage.getItem(validSessionName);

  if (sessionData) {
    return JSON.parse(atob(sessionData));
  }

  return {};
};

exports["default"] = _default;